export default __webpack_public_path__ + "static/media/cgp_help1.76a79376.png";